import axios from '@/axiosInterceptor';

const state = () => ({
  reports: [],
  pagination: {
    currentPage: 1,
    totalPages: 1,
    totalRecords: 0,
  },
  report: [],
});

// actions
const actions = {
  async fetchReports({ commit }, page = 1) {
    try {
      const res = await axios.get(
        `${process.env.API_MONITOR}/api/v1/company_reports?page=${page}`
      );
      commit('setReports', res.data);
      commit('setPagination', res?.headers);
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async runReport(_, id) {
    try {
      const res = await axios.patch(
        `${process.env.API_MONITOR}/api/v1/company_reports/${id}/run_report`
      );
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
};

// mutations
const mutations = {
  setReports(state, data) {
    state.reports = data;
  },
  setReport(state, data) {
    state.report = data;
  },
  setPagination(state, headers) {
    state.pagination = {
      currentPage: headers.currentpage,
      totalPages: headers.totalpages,
      totalRecords: headers.totalitems,
    };
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
